// Official A+ Student Loans / CaseFlow logo. Served from the local
// public/assets/ folder so the branding survives Emergent asset URL
// rotations. If the file is ever accidentally deleted, `LOGO_FALLBACK_URL`
// still points at the canonical Emergent artifact so the UI degrades
// gracefully (visible logo) rather than showing a broken-image icon.
export const LOGO_URL = "/assets/aplus-logo.jpeg";
export const LOGO_FALLBACK_URL =
    "https://customer-assets.emergentagent.com/job_77afd316-a7dd-4662-b1c8-d81e373895c2/artifacts/6wp2jikt_primary_logo.jpeg";

/**
 * Global logo component.
 *
 * The image is intentionally sized via a `className` (default `h-7 w-7`).
 * `object-contain` guarantees the graduation cap + A+ mark is never
 * stretched or clipped on any viewport — desktop, tablet, or mobile.
 *
 * Callers that want just the mark (no wordmark) pass `showWordmark={false}`.
 */
export default function Logo({ className = "h-7 w-7", showWordmark = true }) {
    return (
        <div className="flex items-center gap-2 min-w-0" data-testid="app-logo">
            <img
                src={LOGO_URL}
                onError={(e) => {
                    // If the local asset is missing for any reason, fall
                    // back to the canonical Emergent artifact URL. Runs
                    // exactly once per <img>.
                    if (e.currentTarget.src !== LOGO_FALLBACK_URL) {
                        e.currentTarget.src = LOGO_FALLBACK_URL;
                    }
                }}
                alt="A+ Student Loans"
                className={`${className} rounded-md object-contain shrink-0`}
                loading="eager"
                decoding="async"
                width="28"
                height="28"
            />
            {showWordmark && (
                <span className="font-display font-semibold tracking-tight text-[15px] text-gray-900 truncate">
                    A+ CaseFlow
                </span>
            )}
        </div>
    );
}
